/**
 * @desc 供需匹配报表导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.demandOrder.supplyDemandMatchReportExport.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/wms/demandOrder/supplyDemand/matchReport/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
